import { siteConfig } from '../configs/site-config';
import MainNav from './main-nav';

import { Outlet } from 'react-router-dom';

const Layout: React.FC = () => {
	return (
		<div className="flex flex-col min-h-screen">
			<header className="sticky top-0 z-50 w-full border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
				<div className="flex h-14 items-center">
					<MainNav />
					<div className="flex flex-1 items-center justify-between space-x-2 md:justify-end">
						<nav className="flex items-center">
							{/* Add any additional header items here */}
						</nav>
					</div>
				</div>
			</header>
			<div className="flex-1 flex">
				<Outlet />
			</div>
			<footer className="border-t">
				<div className="container flex h-14 items-center">
					<p className="text-sm text-muted-foreground">
						© 2024 {siteConfig.name}. All rights reserved.
					</p>
				</div>
			</footer>
		</div>
	);
};

export default Layout;
